/**
 * This module manages shoe swap data from ITS api
 * 
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */

import Vue from 'vue'
import axios from 'axios'
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'

import api from '@/api'
import itsApi from '@/api/its'


import {
	VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS,
	VUEX_PREMEDIA_ADD_ROW,
	VUEX_PREMEDIA_EDIT_ROW,
	VUEX_PREMEDIA_SAVE_ROW,
	VUEX_PREMEDIA_SAVE_ROW_SUCCESS,
	VUEX_PREMEDIA_CANCEL_EDIT,
	VUEX_PREMEDIA_UPDATE_ROW_PROP,
	VUEX_PREMEDIA_JOB_UPDATE_PROP,
	VUEX_PREMEDIA_JOB_UPDATE_PROP_CLEAR,
	VUEX_PREMEDIA_DELETE_ROW,
	VUEX_PREMEDIA_CREATE_ITEM,
	VUEX_PREMEDIA_CREATE_ITEM_SUCCESS,
	VUEX_PREMEDIA_UPDATE_ITEM_PROP,
	VUEX_PREMEDIA_UPDATE_ITEM,
	VUEX_PREMEDIA_UPDATE_ITEM_SUCCESS,
	VUEX_PREMEDIA_EDIT_ITEM,
	VUEX_PREMEDIA_EDIT_ITEM_SUCCESS,
	VUEX_PREMEDIA_DELETE_ITEM,
	VUEX_PREMEDIA_DELETE_ITEM_SUCCESS,
	VUEX_PREMEDIA_CLEAR_DATA,
	
	VUEX_PREMEDIA_GET_PRODUCTS,
	VUEX_PREMEDIA_GET_PRODUCTS_SUCCESS,
	VUEX_PREMEDIA_GET_PRODUCTS_FAILURE,
	VUEX_PREMEDIA_ADD_PRODUCT,
	VUEX_PREMEDIA_UPDATE_PRODUCT_TERM,
	VUEX_PREMEDIA_CLEAR_PRODUCT_DATA,

	VUEX_PREMEDIA_GET_ASSETS,
	VUEX_PREMEDIA_GET_ASSETS_SUCCESS,
	VUEX_PREMEDIA_GET_ASSETS_FAILURE,
	VUEX_PREMEDIA_ADD_ASSET,
	VUEX_PREMEDIA_UPDATE_ASSET_TERM,
	VUEX_PREMEDIA_CLEAR_ASSET_DATA,

	VUEX_PREMEDIA_CLONE_DATA,

    VUEX_PREMEDIA_ATTACH_FILE,
    VUEX_PREMEDIA_REMOVE_FILE,
    VUEX_PREMEDIA_REMOVE_FILE_SUCCESS,
    VUEX_PREMEDIA_PUSH_ATTACHMENTS_REMOVED,

    VUEX_PREMEDIA_SET_CANCEL,

} from '@/store/constants/premedia'


import {
    VUEX_JOB_UPDATE_PROP,
    VUEX_JOB_GET_REQUEST,
    VUEX_JOB_CREATE_LOAD, VUEX_JOBS_SET_CANCEL
} from '@/store/constants/jobs'

import {
    VUEX_ATTACHMENTS_DELETE_ATTACHMENT } from '@/store/constants/attachments'



// Row template
const premediaRow_Template = {
	directions: null,
	id:         null,
	isEditing:  true,
    attachments:[],
	items:      [],
	type:       1
}

const state = {
	premediaRows: [],                   // Premedia rows in loaded job (from store.jobs.job)
	premediaRow_Editing: {},            // data copy of row currently being edited
	premediaRow_Copy: {},               // Copy of the edited rows data PRIOR to editing.
	premediaRow_RowPropsToUpdate: {},   // Only edited PROPS on row being edited/added
	premediaRow_ItemsToCreate: [],      // Only created ITEMS on row being edited/added
    premedia_attachmentsRemoved: [],    // temporary list of attachments removed - keeps things from appearing twice

	premedia_JobPropPending: {},        // staging area for job props to be update - call to VUEX_JOBS_

	currentEditingRowIndex: null,     // The index of the current 'premediaRows' being edited
	premediaGroupIsEditing: false,    // Premedia global for row in edit mode

	productsData: [],                 // Product data from ITS API
	productsTerm: null,               // Product term entered by user
	productsLoading: false,           // If are currently being looked up

	assetsData: [],                   // Asset data from ITS API
	assetsTerm: null,                 // Asset term entered by user
	assetsLoading: false,             // If are currently being looked up

    //cancels
    cancels: {
        cancelPremediaRequest:null,
    }
}



const getters = {
	getRowProductItems:(state) => (index) => {
        let data = []
	    if (state.premediaRows[index] && state.premediaRows[index].items.length>0) {
            data = state.premediaRows[index].items.filter((item, i) => {
                if (item.type === 1) {
                    return Object.assign(item, {})
                }
            })
        }
		return data
	},

	getRowAssetItems:(state) => (index) => {
        let data = []
        if (state.premediaRows[index] && state.premediaRows[index].items.length>0) {
            data = state.premediaRows[index].items.filter((item, i) => {
                if (item.type === 2) {
                    return Object.assign(item, {})
                }
            })
        }
		return data
	},

    getRowItemById:(state) => (rowIndex,id) => {
        let ret = []
        if (state.premediaRows[rowIndex] && state.premediaRows[rowIndex].items.length>0) {
            for (var i = 0; i < state.premediaRows[rowIndex].items.length; i++) {
                if (state.premediaRows[rowIndex].items[i].id === id) {
                    ret = cloneDeep(state.premediaRows[rowIndex].items[i])
                }
            }
        }
        return ret
    },

    //strip out attachmentsRemoved files if they are in our assets set  (avoids things appearing twice)
    filterAttachmentsRemoved:(state) => (ret) => {
        ret = cloneDeep(ret)
        if (state.premedia_attachmentsRemoved.length > 0) {
            for (var i = 0; i < state.premedia_attachmentsRemoved.length; i++) {
                ////////////////////////////////////////////
                //comapre IDs
                ////////////////////////////////////////////
                var par_file_id = state.premedia_attachmentsRemoved[i].file_id
                var par_id = state.premedia_attachmentsRemoved[i].id
                var par_temp_id = state.premedia_attachmentsRemoved[i].temp_id
                for (var ii = 0; ii < ret.length; ii++) {
                    var ret_file_id = ret[ii].file_id
                    var ret_id = ret[ii].id
                    var ret_temp_id = ret[ii].temp_id
                    if (par_file_id !== null && par_file_id !== undefined)  {
                        //par_file_id to ret_id
                        if (ret_id !== null && ret_id !== undefined)  {
                            if (par_file_id === ret_id) {
                                ret.splice(ii, 1) // remove
                            }
                        }
                        //par_file_id to ret_file_id
                        if (ret_file_id !== null && ret_file_id !== undefined) {
                            if (par_file_id === ret_file_id) {
                                ret.splice(ii, 1) // remove
                            }
                        }
                    }
                    if (par_id !== null && par_id !== undefined)  {
                        //par_id to ret_id
                        if (ret_id !== null && ret_id !== undefined)  {
                            if (par_id === ret_id) {
                                ret.splice(ii, 1) // remove
                            }
                        }
                    }
                    if (par_temp_id !== null && par_temp_id !== undefined)  {
                        //par_id to ret_id
                        if (ret_temp_id !== null && ret_temp_id !== undefined)  {
                            if (par_temp_id === ret_temp_id) {
                                ret.splice(ii, 1) // remove
                            }
                        }
                    }
                }

            }//i
        }
        return ret
    },

	getProductData:(state) => () => state.productsData,
	getAssetsData:(state) => () => state.assetsData,
}



const actions = {

	// GET ALL PREMEDIA ROWS FROM LOADED JOB
	[VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS]: async({ rootState, commit, dispatch }) => {
	    //cancel token
        await dispatch(VUEX_PREMEDIA_CLEAR_DATA) //this has a cancel inside it
        await commit(VUEX_PREMEDIA_SET_CANCEL,{
            key:'cancelPremediaRequest',
            value:axios.CancelToken.source()
        })

		await api.get(`/jobs/${rootState.jobs.job.id}/premedia`,{
            cancelToken: state.cancels.cancelPremediaRequest.token
        }).then(async (response) => {
			commit(VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS, response.data.data)
		}).catch((err) => {
			console.error(err)
		})
	},

	// ADD PREMEDIA ROW
	[VUEX_PREMEDIA_ADD_ROW]: async({ commit }) => {
		await commit(VUEX_PREMEDIA_ADD_ROW) // Add row
		commit(VUEX_PREMEDIA_EDIT_ROW, {index:0}) // Put row in edit mode
	},

	// EDIT PREMEDIA
	[VUEX_PREMEDIA_EDIT_ROW]: async({ commit }, index) => {
		commit(VUEX_PREMEDIA_EDIT_ROW, {index:index}) // put row [index] in edit mode
	},

	// SAVE PREMEDIA ROW
	[VUEX_PREMEDIA_SAVE_ROW]: async({ rootState, commit, dispatch, getters }, payload) => {
	    var rowId = payload.rowId;

	    //sneak save - just create a new row if one hasn't existed before
        //sneak save doesn't mess with state or UI at all
	    var uploadSneakSave = payload.uploadSneakSave;

		// If saved row
		if ( rowId !== null && rowId ) {
		    //we already have ID, so no need to sneak save
            if (uploadSneakSave!==true) {

                let sendData = cloneDeep(state.premediaRow_Editing)
                let sendData2 = getters.filterAttachmentsRemoved(sendData.items)
                sendData.items = sendData2
                //DO ROW
                await api.patch(`/jobs/${rootState.jobs.job.id}/premedia/${rowId}`, sendData).then(async (response) => {

                    //DO EXITING ROW ITEMS
                    var ret = getters.filterAttachmentsRemoved(state.premediaRow_Editing.items)
                    ret.forEach(async item => {
                        if (item.id) await dispatch(VUEX_PREMEDIA_EDIT_ITEM, {...item, row_id:rowId})
                    })

                    //DO NEW ROW ITEMS
                    ret = getters.filterAttachmentsRemoved(state.premediaRow_ItemsToCreate)
                    if (ret.length) {
                        await dispatch(VUEX_PREMEDIA_CREATE_ITEM, rowId)
                    }

                    //update the job rows if not editing any more
                    await commit(VUEX_PREMEDIA_SAVE_ROW_SUCCESS, response.data.data)
                    let obj = {
                        id:rootState.jobs.job.id,
                        fromPremediaRow:true
                    }
                    dispatch(VUEX_JOB_CREATE_LOAD,obj)


                    //final state for row
                    commit(VUEX_PREMEDIA_EDIT_ROW)

                }).catch((err) => {
                    console.error(err)
                })
            }
		// If new row 
		} else {
		    //filer the dupes
            var ret = cloneDeep(state.premediaRow_Editing)
            var ret2 = getters.filterAttachmentsRemoved(state.premediaRow_Editing.items)
            var ret3 = getters.filterAttachmentsRemoved(state.premediaRow_ItemsToCreate)
            ret.items = ret2 //assign no attachements removed here

            if (ret.items !== null  && ret.items>0 && ret3 !== null && ret3.length>0) {
                //temp_id
                for (var i = 0; i < ret.items.length; i++) {
                    for (var ii = 0; ii < ret3.items.length; ii++) {
                        if (ret.items[i].temp_id !== null && ret.items[i].temp_id !== undefined && ret.items[i].temp_id !== ''
                            && ret3[ii].temp_id !== null && ret3[ii].temp_id !== undefined && ret3[ii].temp_id !== '') {
                            Object.assign(ret.items[i], ret3[ii])
                        }
                    }
                }
            } else{
                ret.items = ret3
            }

            //if sneak save, don't save any of the items now
            //only save them on real save
            if (uploadSneakSave) {
                ret.items = []
            }

            await api.post(`/jobs/${rootState.jobs.job.id}/premedia/`, ret).then(async (response) => {
                await commit(VUEX_PREMEDIA_SAVE_ROW_SUCCESS, response.data.data)



                //update the job rows if not editing any more
                if (uploadSneakSave!==true) {
                    await commit(VUEX_PREMEDIA_SAVE_ROW_SUCCESS, response.data.data)
                    let obj = {
                        id: rootState.jobs.job.id,
                        fromPremediaRow:true
                    }
                    dispatch(VUEX_JOB_CREATE_LOAD, obj)
                }

                //final state for row
                await commit(VUEX_PREMEDIA_EDIT_ROW, {
                    'uploadSneakSave':uploadSneakSave,
                })

            }).catch((err) => {
                console.error(err)
            })

		}

        //update any remaining stuff for new or saved
        if (uploadSneakSave!==true && state.premedia_JobPropPending !== null) {
            if (Object.keys(state.premedia_JobPropPending).length > 0) {
                await dispatch(VUEX_JOB_UPDATE_PROP, state.premedia_JobPropPending)
                commit(VUEX_PREMEDIA_JOB_UPDATE_PROP_CLEAR)
            }
        }

	},

	// CANCEL PREMEDIA ROW EDIT
	[VUEX_PREMEDIA_CANCEL_EDIT]: async({ state, commit, getters }) => {
		//restore to the copy before open
	    await commit(VUEX_PREMEDIA_CANCEL_EDIT)

        //but also kill loader files from appearing
        var rowId = state.premediaRows[state.currentEditingRowIndex].id
        if (rowId !== null) {
            let paramsWithId = {
                attach_to: {
                    model: SILA_FILE_ATTACHMENT_MODEL_JOB_PREMEDIA_ROW,
                    model_id: rowId,
                }
            }
            let loaderfiles = getters.getCompletedFiles(paramsWithId)
            if (loaderfiles && loaderfiles.length > 0) {
                for (var i = 0; i < loaderfiles.length; i++) {
                    commit(VUEX_PREMEDIA_PUSH_ATTACHMENTS_REMOVED,loaderfiles[i])
                }
            }
        }

        //delete row
		if (!state.premediaRows[state.currentEditingRowIndex].id)
			await commit(VUEX_PREMEDIA_DELETE_ROW)

        //final wipe
		commit(VUEX_PREMEDIA_EDIT_ROW)
	},

	// UPDATE PREMEDIA ROW PROP
	[VUEX_PREMEDIA_UPDATE_ROW_PROP]: async({ state, commit }, payload) => {
		commit(VUEX_PREMEDIA_UPDATE_ROW_PROP, payload)
	},

	[VUEX_PREMEDIA_JOB_UPDATE_PROP]: async({commit}, payload) => {
		commit(VUEX_PREMEDIA_JOB_UPDATE_PROP, payload)
	},

	// DELETE PREMEDIA ROW
	[VUEX_PREMEDIA_DELETE_ROW]: async({ rootState, state, commit }) => {
		let currentRow = state.currentEditingRowIndex
		let hasID = state.premediaRows[currentRow].id ? true : false
		
		if (hasID) {
			let id = state.premediaRows[currentRow].id
			await api.delete(`/jobs/${rootState.jobs.job.id}/premedia/${id}`).then(async (response) => {
				commit(VUEX_PREMEDIA_DELETE_ROW, currentRow)
			}).catch((err) => {
				console.error(err)
			})
		} else {
			commit(VUEX_PREMEDIA_DELETE_ROW, currentRow)
		}
	},

	// SAVE PREMEDIA ITEM
	[VUEX_PREMEDIA_CREATE_ITEM]: async({ rootState, state, commit, getters, dispatch }, rowId) => {
		// sanitize for BE before submit	
		var ret = getters.filterAttachmentsRemoved(state.premediaRow_ItemsToCreate)

        await api.post(`/jobs/${rootState.jobs.job.id}/premedia/${rowId}/items`, {items:ret}).then(async (response) => {
            //now push the real items in
			commit(VUEX_PREMEDIA_CREATE_ITEM_SUCCESS, response.data.data)
		}).catch((err) => {
			console.error(err)
		})
	},

	// EDIT PREMEDIA ITEM
	[VUEX_PREMEDIA_EDIT_ITEM]: async({ rootState, state, commit }, payload) => {
	    let data = cloneDeep(payload)
        delete data.created_at
        delete data.file
        delete data.file_id
        delete data.metadata
        delete data.updated_at
        delete data.user_id

		await api.patch(`/jobs/${rootState.jobs.job.id}/premedia/${payload.row_id}/items/${payload.id}`, data).then(async (response) => {
			commit(VUEX_PREMEDIA_EDIT_ITEM_SUCCESS, data)
		}).catch((err) => {
			console.error(err)
		})
	},

	// UPDATE PREMEDIA ITEM PROP
	[VUEX_PREMEDIA_UPDATE_ITEM_PROP]: async({ state, commit }, payload) => {
		commit(VUEX_PREMEDIA_UPDATE_ITEM_PROP, payload)
	},

	// DELETE PREMEDIA ITEM
	[VUEX_PREMEDIA_DELETE_ITEM]: async({ rootState, commit, dispatch, state }, payload) => {
		if(payload.id) {
			await api.delete(`/jobs/${rootState.jobs.job.id}/premedia/${payload.row_id}/items/${payload.id}`).then(async (response) => {
                commit(VUEX_PREMEDIA_DELETE_ITEM_SUCCESS, payload)
			}).catch((err) => {
				console.error(err)
			})
		} else {
            commit(VUEX_PREMEDIA_DELETE_ITEM_SUCCESS, payload)
        }
	},


	[VUEX_PREMEDIA_CLEAR_DATA]: ({ commit }) => {
	    //cancel any pending request
        if (state.cancels.cancelPremediaRequest) {
            state.cancels.cancelPremediaRequest.cancel()
            commit(VUEX_PREMEDIA_SET_CANCEL,{
                key:'cancelPremediaRequest',
                value:null
            })
        }
        commit(VUEX_PREMEDIA_CLEAR_DATA)
	},



	// PRODUCTS
	[VUEX_PREMEDIA_UPDATE_PRODUCT_TERM]: async({ commit, dispatch }, payload) => {
		if (!payload) return
		dispatch(VUEX_PREMEDIA_GET_PRODUCTS, payload)
		commit(VUEX_PREMEDIA_GET_PRODUCTS)
	},

	[VUEX_PREMEDIA_GET_PRODUCTS]: debounce(async ({ commit }, payload) => {
		await itsApi.post(`/products/sila`, {term:payload}).then((response) => {
			if (!payload) return
			commit(VUEX_PREMEDIA_GET_PRODUCTS_SUCCESS, response.data)
		}).catch((err) => {
			commit(VUEX_PREMEDIA_GET_PRODUCTS_FAILURE)
			console.error(err)
		})	
	}, 500),

	[VUEX_PREMEDIA_ADD_PRODUCT]: async({ commit }, payload) => {
		let data = {
			metadata:        JSON.stringify(payload.metadata),
			type:            payload.type,
			note:            payload.note,
			url:             (payload.metadata.thumbSrc) ? encodeURI(payload.metadata.thumbSrc) : null,
			is_approved:     payload.approved,
            file_id:         (payload.file_id) ? payload.file_id : null,
            temp_id:         "temp-"+Math.random(),
            row_index:       state.currentEditingRowIndex,
		}

		commit(VUEX_PREMEDIA_ADD_PRODUCT, data)
	},





	// ASSETS
	[VUEX_PREMEDIA_UPDATE_ASSET_TERM]: async({ commit, dispatch }, payload) => {
		if (!payload) return
		dispatch(VUEX_PREMEDIA_GET_ASSETS, payload)
		commit(VUEX_PREMEDIA_GET_ASSETS)
	},

	[VUEX_PREMEDIA_GET_ASSETS]: debounce(async ({ commit }, payload) => {
		await itsApi.post(`/assets/files/sila`, {term:payload}).then((response) => {
			if (!payload) return
			commit(VUEX_PREMEDIA_GET_ASSETS_SUCCESS, response.data)
		}).catch((err) => {
			commit(VUEX_PREMEDIA_GET_ASSETS_FAILURE)
			console.error(err)
		})	
	}, 500),

	[VUEX_PREMEDIA_ADD_ASSET]: async({ commit }, payload) => {
		let data = {
			metadata:        JSON.stringify(payload.metadata),
			type:            payload.type,
			note:            payload.note,
			url:             encodeURI(payload.metadata.imgSrc),
			is_approved:     payload.approved,
            file_id:         payload.file_id,
            temp_id:         "temp-"+Math.random(),
            row_index:       state.currentEditingRowIndex,
		}

		commit(VUEX_PREMEDIA_ADD_ASSET, data)
	},




    /**
     * File Attachment
     */
    [VUEX_PREMEDIA_ATTACH_FILE]: ({ dispatch, state }, payload) => {
        api.post(`/attachments`, {
            file_id: payload.id,
            model_id: payload.attach_to.model_id,
            model: payload.attach_to.model,
            note: payload.note,
        }).then(async (response) => {
            //add this to the items to save list
            let data = {
                metadata:        {},
                type:            3,
                note:            '',
                url:             '',
                is_approved:     false,
                file_id:         response.data.data.file_id,
                temp_id:         "temp-"+Math.random(),
                row_index:       state.currentEditingRowIndex,
            }
            dispatch(VUEX_PREMEDIA_ADD_PRODUCT,data)

        }).catch((err) => {
            console.error(err)
        })
    },


    [VUEX_PREMEDIA_REMOVE_FILE]: async ({ dispatch, commit }, payload) => {
        await dispatch(VUEX_ATTACHMENTS_DELETE_ATTACHMENT, payload).then((response) => {
            if (!response.status) return
            if (response.status == 200 || response.status == 204) {
                commit(VUEX_PREMEDIA_REMOVE_FILE_SUCCESS, payload)

                //if it has attach_to then this was a temporary item - so no need to delete row
                if (payload.data && payload.data.attach_to === undefined) {
                    var obj = {
                        row_id: payload.model_id,
                        id: payload.data.id,
                        file_id: payload.file_id,
                        payload: payload,
                    }
                    dispatch(VUEX_PREMEDIA_DELETE_ITEM,obj)
                }

            }
        })
    },
}


const mutations = {
	//PREMEDIA
	[VUEX_PREMEDIA_GET_JOB_PREMEDIA_ROWS]: (state, payload) => {
		let data = payload ? payload : []
		data.forEach(x => x.isEditing = false )
		Vue.set( state, 'premediaRows', data)
	},

	[VUEX_PREMEDIA_ADD_ROW]: (state) => {
		// Add template data to row for model
		state.premediaRows.unshift(cloneDeep(premediaRow_Template))
	},

    [VUEX_PREMEDIA_EDIT_ROW]: (state, payload) => {
        //index in this case is row index

        var index=null, isEditing=false
        if (payload && payload.hasOwnProperty('uploadSneakSave') && payload.uploadSneakSave) {
            isEditing=true
            index=0 //sneak save always is the top item - and will always be zero
        }
        if (payload && payload.hasOwnProperty('index')) {
            index = payload.index
            isEditing=true
        }

        // reset to not editing
        state.premediaRows.map(x => x.isEditing = false)
        if (isEditing===false) {
            state.premediaRow_Copy = {}
            state.premediaGroupIsEditing = false
            state.currentEditingRowIndex = -1

            state.premediaRow_Editing = {}
            state.premediaRow_RowPropsToUpdate = {}
            state.premediaRow_ItemsToCreate = []
        } else {
            // is editing - editing a particular index
            if (index != null) {
                state.premediaRow_Copy = cloneDeep(state.premediaRows[index])
                state.premediaGroupIsEditing = true
                state.currentEditingRowIndex = index

                state.premediaRow_Editing = state.premediaRows[index]
                state.premediaRows[index].isEditing = true
            }
        }
        
    },

	[VUEX_PREMEDIA_UPDATE_ROW_PROP]: (state, payload) => {
		Object.assign(state.premediaRows[payload.index], payload.data)
		Object.assign(state.premediaRow_RowPropsToUpdate, payload.data)
	},

	[VUEX_PREMEDIA_JOB_UPDATE_PROP]: (state, payload) => {
	    if (payload !== null && state.premedia_JobPropPending !== null) {
            Object.assign(state.premedia_JobPropPending, payload)
        }
	},

	[VUEX_PREMEDIA_JOB_UPDATE_PROP_CLEAR]: (state) => {
		state.premedia_JobPropPending = null
	},


	[VUEX_PREMEDIA_SAVE_ROW_SUCCESS]: (state, payload) => {
		let obj = {...payload, isEditing:false}
        state.premediaRows[state.currentEditingRowIndex].id = payload.id
        state.premediaRows[state.currentEditingRowIndex].directions = payload.directions
	},

	[VUEX_PREMEDIA_CANCEL_EDIT]: (state) => {
        //restore state to original codition
        Object.assign(state.premediaRows[state.currentEditingRowIndex], state.premediaRow_Copy)
	},

	[VUEX_PREMEDIA_DELETE_ROW]: (state) => {
		state.premediaRows.splice(state.currentEditingRowIndex, 1)
		state.premediaGroupIsEditing = false
	},

	[VUEX_PREMEDIA_CREATE_ITEM]: (state, payload) => {

	},

	[VUEX_PREMEDIA_CREATE_ITEM_SUCCESS]: (state, payload) => {
	    for (var i=0;i<state.premediaRow_ItemsToCreate.length;i++) {
            var createItem = state.premediaRow_ItemsToCreate[i]
            for (var ii = 0; ii < state.premediaRows[state.currentEditingRowIndex].items.length; ii++) {
                var idx = -1
                var item = state.premediaRows[state.currentEditingRowIndex].items[ii]
                if (item.id == createItem.id) {
                    idx = ii
                }
                if (idx > -1) {
                    state.premediaRows[state.currentEditingRowIndex].items.splice(idx, 1)
                    state.premediaRow_Copy.items.splice(idx, 1)
                }
            }
        }//try to delete from existing (via id)


        payload.forEach((item) => {
			state.premediaRows[state.currentEditingRowIndex].items.push(cloneDeep(item))
		})
		state.premediaRow_ItemsToCreate = []
	},

	/*
	// This is needed to conditionally update an item (needed for note) that is either 
	// existing (update item via api) or new (create batch)
	*/
	[VUEX_PREMEDIA_UPDATE_ITEM_PROP]: (state, payload) => {
		let data = payload.data

		// update existing item
		if (payload.id !== undefined && payload.id !== null) {
            var didit = false;
            for (var i=0;i<state.premediaRows[state.currentEditingRowIndex].items.length;i++) {
                var item = state.premediaRows[state.currentEditingRowIndex].items[i]
                if (item.id === payload.id) {
                    Object.assign(state.premediaRows[state.currentEditingRowIndex].items[i], data)
                    didit = true;
                }
            }

            //so for uploaded assets, when they are first created, they get merged in with an ID set
            //in this case, if nothing has been found, we will then check the itemstocreate record
            //this way we can attach a note for new uploaded items
            if (didit===false) {
                for (var ii=0;ii<state.premediaRow_ItemsToCreate.length;ii++) {
                    var item = state.premediaRow_ItemsToCreate[ii]
                    if (item.file_id === payload.id) { //yes, compare file_id to id
                        Object.assign(state.premediaRow_ItemsToCreate[ii], data)

                    }
                }
            }

		} else {
			// update unsaved item
            if (payload.temp_id !== null && payload.temp_id !== '' && payload.temp_id !== '') {
                //try items to create
                for (var i = 0; i < state.premediaRow_ItemsToCreate.length; i++) {
                    var item = state.premediaRow_ItemsToCreate[i]
                    if (item.temp_id === payload.temp_id) {
                        Object.assign(state.premediaRow_ItemsToCreate[i], data)
                    }
                }

                //try items to edit
                if (state.premediaRow_Editing.items !== undefined && state.premediaRow_Editing.items.length>0) {
                    for (var i = 0; i < state.premediaRow_Editing.items.length; i++) {
                        var item = state.premediaRow_Editing.items[i]
                        if (item.temp_id === payload.temp_id) {
                            Object.assign(state.premediaRow_Editing.items[i], data)
                        }
                    }
                }
            }
		}
	},

	[VUEX_PREMEDIA_EDIT_ITEM_SUCCESS]: (state, payload) => {
	    //Object.assign(state.premediaRows[payload.row_index].items[payload.items_index], payload.data)
	},

	[VUEX_PREMEDIA_DELETE_ITEM_SUCCESS]: (state, payload, commit) => {
	    //try to delete from existing (via id)
        var idx = -1
        if (payload.id !== undefined && payload.id !== null && payload.id !== '') {
            if (state.premediaRows[state.currentEditingRowIndex].items !== undefined && state.premediaRows[state.currentEditingRowIndex].items.length >0) {
                for (var i = 0; i < state.premediaRows[state.currentEditingRowIndex].items.length; i++) {
                    var item = state.premediaRows[state.currentEditingRowIndex].items[i]
                    if (item.id === payload.id) {
                        idx = i
                    }
                }

                if (idx > -1) {
                    state.premediaRows[state.currentEditingRowIndex].items.splice(idx, 1)
                    state.premediaRow_Copy.items.splice(idx, 1)
                }
            }

            //AND Check editing
            idx = -1
            if (state.premediaRow_Editing.items !== undefined && state.premediaRow_Editing.items.length>0) {
                for (var i = 0; i < state.premediaRow_Editing.items.length; i++) {
                    var item = state.premediaRow_Editing.items[i]
                    if (item.id === payload.id) {
                        idx = i
                    }
                }

                if (idx > -1) {
                    state.premediaRow_Editing.items.splice(idx, 1)
                }
            }

        }


        //try to delete from items to create (via temp_id)
        idx = -1
        if (payload.temp_id !== undefined && payload.temp_id !== null && payload.temp_id !== '') {
            if (state.premediaRow_ItemsToCreate.length>0) {
                for (var i = 0; i < state.premediaRow_ItemsToCreate.length; i++) {
                    var item = state.premediaRow_ItemsToCreate[i]
                    if (item.temp_id === payload.temp_id) {
                        idx = i
                    }
                }
                if (idx > -1) {
                    state.premediaRow_ItemsToCreate.splice(idx, 1)
                }
            }

            //AND Check editing
            idx = -1
            if (state.premediaRow_Editing.items !== undefined && state.premediaRow_Editing.items.length>0) {
                for (var i = 0; i < state.premediaRow_Editing.items.length; i++) {
                    var item = state.premediaRow_Editing.items[i]
                    if (item.temp_id === payload.temp_id) {
                        idx = i
                    }
                }

                if (idx > -1) {
                    state.premediaRow_Editing.items.splice(idx, 1)
                }
            }
        }



        //push to temp filter array
        state.premedia_attachmentsRemoved.push(payload);
	},

	[VUEX_PREMEDIA_CLEAR_DATA]: (state) => {
		state.premediaRows = []
        state.premediaRow_Editing = {}
        state.premediaRow_Copy = {}
        state.premediaRow_RowPropsToUpdate = {}
        state.premediaRow_ItemsToCreate = []
        state.premedia_attachmentsRemoved = []

        state.currentEditingRowIndex = null
        state.premediaGroupIsEditing = false
	},



	// PRODUCTS
	[VUEX_PREMEDIA_GET_PRODUCTS]: (state) => {
		state.productsLoading = true
	},

	[VUEX_PREMEDIA_GET_PRODUCTS_SUCCESS]: (state, payload) => {
		state.productsData = payload
		state.productsLoading = false
	},

	[VUEX_PREMEDIA_GET_PRODUCTS_FAILURE]: (state) => {
		state.productsLoading = false
	},

	[VUEX_PREMEDIA_CLEAR_PRODUCT_DATA]: (state) => {
		state.productsData = []
		state.productsTerm = null
		state.productsLoading = false
	},
	
	[VUEX_PREMEDIA_ADD_PRODUCT]: (state, payload) => {
		// push them to current data to display item before save 
		state.premediaRows[state.currentEditingRowIndex].items.push(cloneDeep(payload))
		// push to staging array for item batch upload
		state.premediaRow_ItemsToCreate.push(cloneDeep(payload))
	},





	// ASSETS
	[VUEX_PREMEDIA_GET_ASSETS]: (state) => {
		state.assetsLoading = true
	},

	[VUEX_PREMEDIA_GET_ASSETS_SUCCESS]: (state, payload) => {
		state.assetsData = payload
		state.assetsLoading = false
	},

	[VUEX_PREMEDIA_GET_ASSETS_FAILURE]: (state) => {
		state.assetsLoading = false 
	},

	[VUEX_PREMEDIA_CLEAR_ASSET_DATA]: (state) => {
		state.assetsData = []
		state.assetsTerm = null
		state.assetsLoading = false
	},

	[VUEX_PREMEDIA_ADD_ASSET]: (state, payload) => {
		// push them to current data to display item before save 
		state.premediaRows[state.currentEditingRowIndex].items.push(cloneDeep(payload))
		// push to staging array for item batch upload
		state.premediaRow_ItemsToCreate.push(cloneDeep(payload))
	},

    // PREMEDIA ATTACHMENTS
    [VUEX_PREMEDIA_REMOVE_FILE_SUCCESS]: (state, payload) => {

    },

    [VUEX_PREMEDIA_PUSH_ATTACHMENTS_REMOVED]: (state, payload) => {
        state.premedia_attachmentsRemoved.push(payload)
    },


    //SET CANCELS
    [VUEX_PREMEDIA_SET_CANCEL]: (state, payload) => {
        state.cancels[payload.key] = payload.value
    },
}


export default {
	state,
	getters,
	actions,
	mutations,
}
